import React, { Component } from 'react';
import ButtonPanel from '../../QbmPage/ButtonPanel';
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { getRooms, setRoomItem, getRoomStudents } from '../actions';
import { MODAL_ROOM_FORM, showModal, MODAL_ROOM_DELETE } from '../../../modules/modals';
import classNames from 'classnames';
import moment from 'moment';

class Rooms extends Component {
  static contextTypes = {formatMessage: PropTypes.any};

  componentDidMount(){
    this.props.getRooms();
  }

  render() {
    const {formatMessage} = this.context;
    const { rooms, room } = this.props;
    return (
      <div className="qbm-accordion-panel rooms">
        <div className="qbm-accordion-component">
          <div className="qbm-accordion-title">
            {formatMessage('titleClassRoomSidebar')}
          </div>
          <div className="posr qbm-accordion-body open">
            <div className="qbm-accordion-content">
              {rooms.map(item => (
                <div
                  key={`room-item-${item.id}`}
                  className={classNames("qbm-accordion-content__item ", {'qbm-accordion-content__item--selected': room && room.id == item.id ? true : false})}
                  onClick={() => {
                    this.props.setRoomItem(item);
                    this.props.getRoomStudents(item.id);
                  }}
                >
                  <span className="text-ellipsis">{item.title}</span> <span className={item.status && moment() >= moment(item.active_from * 1000) && moment() <= moment(item.active_to * 1000) ? 'marker-published' : 'marker-unpublished'} />
                </div>
              ))}
              {/* <div className="qbm-accordion-content__item qbm-accordion-content__item--selected"><span className="text-ellipsis">Test #2</span></div> */}
            </div>
            <ButtonPanel
              handleAddCreateClick = {() => {
                const { showModal } = this.props;
                showModal({
                  modalType : MODAL_ROOM_FORM,
                  modalProps : {
                    initialValues: {
                      active_to: moment().add(1, 'days'),
                      active_from: moment(),
                      status: true
                    }
                  }
                });
              }}
              handleDeleteClick = {() => {
                const { showModal } = this.props;
                showModal({
                  modalType : MODAL_ROOM_DELETE,
                  modalProps : {
                    room_id: room.id
                  }
                });
              }}
              handleUpdateClick = {() => {
                const { showModal } = this.props;
                showModal({
                  modalType : MODAL_ROOM_FORM,
                  modalProps : {
                    initialValues: {
                      ...room, 
                      active_to: room.active_to * 1000,
                      active_from: room.active_from * 1000,
                      status: room.status ? moment() >= moment(room.active_from * 1000) && moment() <= moment(room.active_to * 1000) : false
                    }
                  }
                });
              }}
              isUpdateActive = {!!room}
              isDeleteActive = {!!room}
            />
          </div>
          
        </div>
        
      </div>
    );
  }
}


const mapStateToProps = (state, ownProps) => ({
  rooms: state.rooms.list,
  room: state.rooms.item
})

const mapDispatchToProps = {
  getRooms,
  showModal,
  setRoomItem,
  getRoomStudents,
}

export default connect(mapStateToProps, mapDispatchToProps)(Rooms)




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/RoomsAndStudents/Rooms/index.jsx